import React, { FC, ReactNode } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Tooltip,
  IconButton,
} from "@mui/material";
import { useAppTheme } from "@/utils/theme";
import InfoIcon from "@mui/icons-material/Info";

interface FormSectionProps {
  title?: string;
  children: ReactNode;
  tooltip?: string;
}

export const FormSection: FC<FormSectionProps> = ({
  title,
  children,
  tooltip,
}) => {
  const theme = useAppTheme();

  return (
    <Card variant="outlined">
      <CardContent>
        {title && (
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{ pt: 1, pb: 1 }}
          >
            <Typography
              color={theme.palette.primary.main}
              variant="titleSmall"
              component="h2"
              gutterBottom
              fontWeight={700}
            >
              {title}
            </Typography>
            {tooltip && (
              <Tooltip title={tooltip} arrow>
                <IconButton>
                  <InfoIcon
                    fontSize="small"
                    sx={{ color: theme.palette.primary.dark }}
                  />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        )}

        <Box display="flex" flexDirection="column" gap={2}>
          {children}
        </Box>
      </CardContent>
    </Card>
  );
};
